import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AccessService} from './services/access.service';
import {LocalStorageService} from './services/local-storage.service';
import {DataService} from './services/data.service';
import {firstValueFrom} from "rxjs";

export const AuthGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

    const accessService = inject(AccessService);
    const router = inject(Router);
    const localStorageService = inject(LocalStorageService);
    const dataService = inject(DataService);

    const token = localStorageService.getItem('token');

    if (token) {
        accessService.token = token;

        const response = await firstValueFrom(dataService.request('User/get'));

        if (response.error) {
            router.navigate(['/login']);
            return false;
        } else {
            accessService.user = response.user;
            return true;
        }
    } else {
        router.navigate(['/login']);
        return false;
    }

}
